import { useState, useEffect } from "react";

const C = {
  darkGreen:   "#052C0C",
  limeGreen:   "#9ACA44",
  oliveGreen:  "#819951",
  pageBg:      "#FFFFFF",
  cardBg:      "#F7FAF4",
  textPrimary: "#102216",
  textBody:    "rgba(16,34,22,0.78)",
  border:      "rgba(5,44,12,0.16)",
};

const NAV_LINKS = ["#/About", "#/Contact", "#/FAQ"];
const LOGO_SRC = "https://syntropypro.com/wp-content/uploads/2026/04/SATFPM-LOGO-1.png";

const FAQ_GROUPS = [
  {
    title: "MILLENNIUM SOYA Non-GMO MILK POWDER",
    items: [
      {
        q: "Is this safe for those who has hyper acidity and Gerd?",
        a: `Yes. Most people with hyperacidity or GERD tolerate soya milk really well. Soya is naturally low in fat, and low-fat foods tend to produce less stomach acid. That means they’re less likely to trigger heartburn or reflux. The product is also non-dairy, so it avoids the heaviness that full-cream milk sometimes causes in sensitive stomachs.
        
There are a few things worth understanding. Acid reflux gets worse when the stomach is overloaded with oily food, spicy meals, caffeine or when the lower esophageal sphincter becomes irritated. Soya milk sits on the gentle side of the spectrum. It's plant-based, light, and doesn’t add pressure on the stomach. Some people even find it soothing.
        
Still, every body reacts uniquely. If someone is extremely sensitive, it helps to try it in small amounts at first, preferably after a meal rather than on an empty stomach. Mixing it with warm water is usually easier for the stomach too.

Overall, Millennium Soya is generally considered safe and stomach-friendly for people with hyperacidity and GERD. It fits well with a low-fat, plant-based approach that doctors often recommend for managing reflux. For long-term or severe symptoms, it’s always smart to pair the product with medical guidance.`,
      },
      {
        q: "Is Millenniums Soya Non-GMO Milk Powder safe for pregnant and lactating women?",
        a: `For the most part — yes. Because it’s a soy-based milk powder, it offers plant protein, calcium (if fortified), and is dairy-free, which can be a good alternative when pregnant or breastfeeding. According to sources, moderate soy consumption (about a serving or two of soy milk per day) during pregnancy is considered safe.
(https://www.healthline.com/health/pregnancy/soy-pregnancy)

Here are the matters to keep in mind:

✔ What makes it suitable

Soy milk can provide nutrients useful in pregnancy and lactation (protein, sometimes calcium, etc.).

Studies suggest that adequate soy intake in pregnancy was associated with lower risk of gestational diabetes in
some groups.

Non-dairy plant milks help those who are lactose intolerant, which sometimes arises or is more troublesome during pregnancy or during breastfeeding.

⚠ What to watch / limitations

If the mother has a soy allergy, obviously soy should be avoided.

Some sources caution that very high soy intake in sensitive conditions (kidney disease, severe gastrointestinal conditions) may need extra supervision.

Lactating women: while many sources say soy milk is acceptable, one advises “only use a small amount ... use it when necessary.”

Always pair this with a balanced diet: soy milk alone doesn’t cover everything a pregnant or lactating woman
needs.`,
      },
      {
        q: "WHY IS SOY MILK BEST DIETARY SUPPLIMENT FOR HYPERTENSIVE PERSON WITH STATIN MEDICATIONS??",
        a: `Soy milk sits in a sweet spot for hypertensive patients on statins because it supports the heart without interfering with their medication. The magic is in its nutrient profile. Soy is naturally low in saturated fat and contains plant proteins that help reduce LDL cholesterol. Statins work on the liver to lower cholesterol production, while soy proteins help the body clear cholesterol more efficiently. They complement each other like teammates working on different sides of the same goal.

Soy milk also contains isoflavones, which are plant compounds known to help relax blood vessels, improve endothelial function and slightly lower blood pressure over time. For someone managing hypertension, that gentle vasodilation can feel like a relief rather than a risk. It’s plant-based, so there’s none of the heavy fat load that can raise cholesterol or irritate the cardiovascular system.

Another advantage: soy milk gives protein and nutrients without the sodium content found in many processed foods. Lower sodium means better blood pressure control. High-fiber plant diets have a long track record of helping hypertensive patients stabilize their numbers.

Most importantly, soy milk does not conflict with statins. There’s no known harmful interaction. Instead, its cholesterol-lowering effect works in harmony with the medication. The pairing is like reinforcing the heart’s defenses from two different angles.

The beautiful part is how consistent intake of soy fits into a heart-friendly lifestyle. It’s not dramatic or harsh. It’s gentle, supportive and sustainable. This makes it a smart choice for anyone committed to managing hypertension while staying on statin therapy.`,
      },
      {
        q: "Pwede ba ito sa may diabetes?",
        a: `Pwede, as long as mindful ang intake.
Millennium Soya has low sugar (0–0.5g) and good fiber. That combo slows glucose spikes, like a gentle brake pedal. It won’t replace medication, but it slides nicely into a diabetic-friendly diet.`,
      },
      {
        q: "Nakakatulong ba ito sa may high cholesterol?",
        a: `Yes.
Since it has 0g cholesterol, 0g saturated fat, and is mostly unsaturated fat, it becomes the kind of drink cardiologists clap for. Soy proteins help lower LDL (“bad cholesterol”). Think of it as sweeping crew for your bloodstream.`,
      },
      {
        q: "Pwede ba ito sa may fatty liver?",
        a: `Reasonably yes.
Low fat. No cholesterol. Plant-based.
It doesn’t add burden to the liver, and the protein supports tissue healing. Just avoid over-sweetening it.`,
      },
      {
        q: "Pwede ba ito sa bata?",
        a: `Yes.
It offers 9–10g protein, calcium, and iron per serving. Growing kids need those like artists need paint.
Kung may allergy history, introduce slowly.`,
      },
      {
        q: "Pwede ba ito sa may anemia?",
        a: `Yes.
It contains iron (1–15 mg) which supports hemoglobin production.
Better absorption if paired with vitamin C (like calamansi water).`,
      },
      {
        q: "Good ba ito for constipation?",
        a: `Yes.
May dietary fiber and plant-based proteins that help bowels move with less drama.
Kung sanay sa dairy, soy might feel lighter.`,
      },
      {
        q: "Pwede ba ito sa may osteoporosis?",
        a: `Helpful.
Calcium (40–50 mg) and isoflavones support bone density. Think of it as nourishment that gently fortifies the skeleton.`,
      },
      {
        q: "Nakakatulong ba sa brain fog?",
        a: `Possibly.
The label highlights energy boost and brain function, which ties to soy’s amino acids that help with neurotransmitter production.
Hindi magical, pero supportive.`,
      },
      {
        q: "Pwede ba ito sa insomnia?",
        a: `Some people find warm soy comforting.
Protein + warm drink = relaxed nervous system.
It isn’t a sedative, pero it sets the mood for sleep.`,
      },
      {
        q: "Pwede ba ito sa may thyroid problems?",
        a: `Pwede with spacing.
Soy can interfere with thyroid medication absorption if taken sabay.
Take soy 4 hours apart from thyroid meds.`,
      },
      {
        q: "Pwede ba ito sa may kidney problem?",
        a: `Case-to-case.
Plant protein is gentler, but people with CKD need regulated protein.
Always ask the nephrologist if the kidneys need rest or support.`,
      },
      {
        q: "Pwede ba sa may gout?",
        a: `Studies from Japan, Singapore, and Harvard found that soy foods may have purines, but the body reacts to them differently from animal purines. The purines in plants are like gentle visitors. They don’t cause the inflammatory spike that red meat, organ meat, and seafood cause. Sa Tagalog, plant purines behave more like nakikiraan lang, hindi sila pasaway.

Now, let’s talk Millennium Soya.

This product is made from skinless, Non-GMO Canadian soybeans. Removing the skin removes much of the insoluble fiber and compounds that sometimes make digestion heavy. Skin-free soy is easier on the gut, easier on the kidneys, and leads to a smoother metabolic process. That means the purine load becomes even less impactful compared to whole-bean soybean products.

Plus, Millennium Soya has these traits that are friendly to gout sufferers:
• 0g cholesterol – which helps reduce inflammation
• Low fat – less metabolic burden
• Plant protein – proven to reduce long-term uric acid buildup
• Isoflavones – compounds shown in studies to have mild anti-inflammatory effects

Put them together and you get a drink that behaves like a calm, clean protein source. No heavy purines. No surprise attacks on your joints.

Another important angle: Many people with gout avoid proteins out of fear, then end up undernourished. Soy, especially in powdered milk form, gives them protein without the punishment.

You can imagine it like this:
Animal-based purines are thunder.
Soy-based purines are drizzle.

Same category, very different weather.

The real villains for gout patients are:
• red meat
• bulalo, isaw, kidneys, liver
• sardines and shellfish
• alcohol (lalo beer)
• sugary drinks

Soy doesn’t belong anywhere near that list.

This is why most rheumatologists will say:
Soy is not the enemy.
The enemy is inflammation, and Millennium Soya doesn’t feed that fire.`,
      },
      {
        q: "Pwede ba ito sa may biglaang kabag or bloating?",
        a: `Some may feel slight gas because soy is fiber-rich.
Pero kung “skin-free” soy tulad nito, digestion is usually smoother.`,
      },
      {
        q: "May allergic reactions ba pwede mangyari?",
        a: `Kung may soy allergy, avoid.
Symptoms include skin itchiness, swelling, or digestive upset.
Pero rare ang soy allergy in adults.`,
      },
      {
        q: "Pwede ba sa may weight loss goals?",
        a: `Yes.
High protein + low calorie (35–45 kcal) = fuller feeling without unnecessary calories.
Perfect sa mga gustong maging “lean but chill.”`,
      },
      {
        q: "Pwede ba sa mga nag-gym?",
        a: `Absolutely.
Soy provides complete protein—all essential amino acids.
Good for recovery, especially if ayaw mo ng whey.`,
      },
      {
        q: "Pwede ba ito sa mga seniors?",
        a: `Super yes.
Easy to digest, gentle on the stomach, supports bones, and boosts immunity.`,
      },
      {
        q: "Ano mararamdaman sa unang inom?",
        a: `Most people feel:
• lightness in digestion
• mild energy lift
• a steady, calm fullness

Some might feel slight gas habang nag-aadjust ang tiyan.`,
      },
      {
        q: "Pwede ba araw-araw?",
        a: `Yes.
But always stay mindful of your overall nutrition, especially if you rely heavily on supplements for meals.`,
      },
      {
        q: "Pwede bang ihalo sa kape?",
        a: `Pwede.
Just don’t boil it long para hindi mabago ang texture.`,
      },
      {
        q: "Pwede ba sa mga nag-iwas sa dairy?",
        a: `Perfect.
Lactose-free, cholesterol-free, dairy-free.
Your stomach will sing hallelujah.`,
      },
      {
        q: "Pwede ba ito sa may anxiety?",
        a: `Yes.
Not a cure, but warm soy can be grounding.
Protein helps stabilize blood sugar, and stable blood sugar means a calmer mind.`,
      },
      {
        q: "Bakit \"Skinless\" ang gamit sa Millennium Soya? May pinagkaiba ba ito  sa regular na soy milk?",
        a: `Malaki ang pinagkaiba. Ang balat ng soybean (soy hull) ay nagtataglay ng mga compounds na  nagdudulot ng "beany" or "grassy" na lasa at madalas ay sanhi ng pagkakaroon ng gas o kabag.  Sa pag-remove ng skin, mas nagiging smooth ang texture, mas madaling matunaw (easy to  digest), at mas bawas ang purine content. Para itong pagkain ng kanin na walang iba, puro  sustansya lang ang nakukuha mo.`,
      },
      {
        q: "Ligtas ba ito sa mga may Breast Cancer or Myoma  (Estrogen-sensitive conditions)?",
        a: `Ito ay isa sa mga pinakamalaking myths tungkol sa soy. Ang soy ay may Phytoestrogens (plant-  based), na iba sa human estrogen. Ayon sa American Cancer Society at Mayo Clinic, ang  moderate consumption ng soy ay hindi nagpapalala ng myoma o breast cancer; sa katunayan, ang  isoflavones sa soy ay maaaring makatulong sa pag-block ng mas matapang na human estrogen  sa katawan. Gayunpaman, kung ikaw ay sumasailalim sa hormonal therapy, pinakamainam pa  ring kumonsulta sa iyong oncologist.`,
      },
      {
        q: "Pwede ba itong ihalo sa mainit na tubig? Hindi ba  masisira ang nutrients?",
        a: `Pwedeng-pwede! Ang Millennium Soya ay powder form na ginawa para matunaw sa tubig.  Gamitin ang warm to hot water (huwag yung bagong kulong-kulo o boiling point) para mapanatili  ang integridad ng protina at vitamins. Mas masarap at mas soothing ito sa tiyan kapag  maligamgam.`,
      },
      {
        q: "Nakakatulong ba ito sa mga nakakaranas ng  Menopause?",
        a: `Yes! Ang soy ay sikat bilang "natural friend" ng mga kababaihang nasa menopause stage. Ang  taglay nitong isoflavones ay nakakatulong sa pag-manage ng hot flashes at night sweats. Dahil  bumababa ang bone density sa edad na ito, ang calcium content ng Millennium Soya ay malaking  tulong din para iwas-osteoporosis.`,
      },
      {
        q: "Safe ba ito sa mga may Gallstones (Bato sa Apdo)?",
        a: `Oo. Ang mga taong may gallstones ay pinapayuhang umiwas sa high-fat at high-cholesterol na  gatas (dairy). Dahil ang Millennium Soya ay 0g Cholesterol at Low Fat, hindi nito pinapahirapan  ang apdo. Mas "light" ito at hindi trigger sa gallbladder attacks kumpara sa regular na full-cream  milk.`,
      },
      {
        q: "Pwede ba itong gawing \"Meal Replacement\" kung  nagmamadali?",
        a: `Pwede itong magsilbing light snack o "bridge" sa pagitan ng meals dahil sa 9“10g protein nito  na nakakabusog. Pero para maging ganap na meal replacement (halimbawa, breakfast), mas  maganda kung hahaluan mo ito ng oats, saging, o chia seeds para madagdagan ang  carbohydrates at fiber na kailangan ng katawan sa buong umaga.`,
      },
      {
        q: `Gaano katagal ang "Shelf Life" nito pagkatapos buksan?`,
        a: `Dahil ito ay nasa powder form, tumatagal ito basta“t itatago sa isang cool dry place at nakasara nang mahigpit ang lalagyan. Iwasan ang direktang sikat ng araw at wag gumamit ng basang kutsara sa pagkuha ng powder para hindi mamuo o magka-molds. Consume within 1-2 months after opening for best flavor and freshness.`,
      },
      {
        q: `May "After-taste" ba ito tulad ng ibang soy drinks?`,
        a: `Halos wala. Dahil ito ay "Skinless" at Non-GMO, nawala yung mapakla o malansang lasa na karaniwang reklamo sa ibang soy milk. Ang Millennium Soya ay may mild, creamy, at natural na lasa na madaling tanggapin kahit ng mga bata o pihikan sa panlasa.`,
      },
      {
        q: "Pwede ba ito sa mga taong may Acne-prone skin?",
        a: `Maraming dermatologists ang nagrerekomenda na lumipat mula sa dairy milk papuntang soy milk ang mga may malalang acne. Ang dairy milk kasi ay may hormones na pwedeng mag-trigger ng breakouts. Ang soy ay dairy-free at may anti-inflammatory properties, kaya mas friendly ito sa mga gustong magkaroon ng clearer skin.`,
      },
      {
        q: "Is this safe for those who has hyper acidity and Gerd?",
        a: `Yes. Most people with hyperacidity or GERD tolerate soya milk really well. Soya is naturally low in fat, and low-fat foods tend to produce less stomach acid. That means they“re less likely to trigger heartburn or reflux. The product is also non-dairy, so it avoids the heaviness that full-cream milk sometimes causes in sensitive stomachs.`,
      },
      {
        q: "Is Millenniums Soya Non-GMO Milk Powder safe for pregnant and lactating women?",
        a: `For the most part — yes. Because it“s a soy-based milk powder, it offers plant protein, calcium (if fortified), and is dairy“free, which can be a good alternative when pregnant or breastfeeding.
According to sources, moderate soy consumption (about a serving or two of soy milk per day) during pregnancy is considered safe.
(https://www.healthline.com/health/pregnancy/soy-pregnancy)`,
      },
      {
        q: "WHY IS SOY MILK BEST DIETARY SUPPLEMENT FOR HYPERTENSIVE PERSON WITH STATIN MEDICATIONS?",
        a: `Soy milk sits in a sweet spot for hypertensive patients on statins because it supports the heart without interfering with their medication. The magic is in its nutrient profile. Soy is naturally low in saturated fat and contains plant proteins that help reduce LDL cholesterol. Statins work on the liver to lower cholesterol production, while soy proteins help the body clear cholesterol more efficiently.
They complement each other like teammates working on different sides of the same goal.`,
      },
      {
        q: "Pwede ba ito sa may diabetes?",
        a: `Pwede, as long as mindful ang intake.
Millennium Soya has low sugar (0“0.5g) and good fiber. That combo slows glucose spikes, like a  gentle brake pedal. It won“t replace medication, but it slides nicely into a diabetic-friendly diet.`,
      },
      {
        q: "Nakakatulong ba ito sa may high cholesterol?",
        a: `Yes.
Since it has 0g cholesterol, 0g saturated fat, and is mostly unsaturated fat, it becomes the kind of drink cardiologists clap for. Soy proteins help lower LDL (“bad cholesterol”). Think of it as sweeping crew for your bloodstream.`,
      },
      {
        q: "Pwede ba ito sa may fatty liver?",
        a: `Reasonably yes.
Low fat. No cholesterol. Plant-based.
It doesn“t add burden to the liver, and the protein supports tissue healing. Just avoid over-sweetening it.`,
      },
      {
        q: "Pwede ba ito sa bata?",
        a: `Yes.
It offers 9“10g protein, calcium, and iron per serving. Growing kids need those like artists need paint.
Kung may allergy history, introduce slowly.
        `,
      },
      {
        q: "Pwede ba ito sa may anemia?",
        a: `Yes.
It contains iron (1“15 mg) which supports hemoglobin production. Better absorption if paired with vitamin C (like calamansi water).`,
      },
      {
        q: "Good ba ito for constipation?",
        a: `Yes.
May dietary fiber and plant-based proteins that help bowels move with less drama. Kung sanay sa dairy, soy might feel lighter.`,
      },
      {
        q: "Pwede ba ito sa may osteoporosis?",
        a: `Helpful.
Calcium (40“50 mg) and isoflavones support bone density. Think of it as nourishment that gently fortifies the skeleton.`,
      },
      {
        q: "Nakakatulong ba sa brain fog?",
        a: `Possibly.
The label highlights energy boost and brain function, which ties to soy“s amino acids that help with neurotransmitter production.
Hindi magical, pero supportive.`,
      },
    ],
  },
  // {
  //   title: "Products & Ingredients",
  //   items: [
  //     {
  //       q: "Are SAT products FDA registered?",
  //       a: "Yes. Our products follow applicable Philippine FDA registration and labeling requirements.",
  //     },
  //     {
  //       q: "Are your products natural?",
  //       a: "Our formulas are built around naturally sourced ingredients and quality-controlled manufacturing practices.",
  //     },
  //     {
  //       q: "How should I choose the right product?",
  //       a: "Start with your health goals and message us through the contact page so our team can recommend a product path.",
  //     },
  //   ],
  // },

  // {
  //   title: "Products & Ingredients",
  //   items: [
  //     {
  //       q: "Are SAT products FDA registered?",
  //       a: "Yes. Our products follow applicable Philippine FDA registration and labeling requirements.",
  //     },
  //     {
  //       q: "Are your products natural?",
  //       a: "Our formulas are built around naturally sourced ingredients and quality-controlled manufacturing practices.",
  //     },
  //     {
  //       q: "How should I choose the right product?",
  //       a: "Start with your health goals and message us through the contact page so our team can recommend a product path.",
  //     },
  //   ],
  // },
  // {
  //   title: "Orders & Shipping",
  //   items: [
  //     {
  //       q: "How long does shipping take?",
  //       a: "Domestic shipping usually takes 3–7 business days, while international timelines vary by destination.",
  //     },
  //     {
  //       q: "Do you offer international shipping?",
  //       a: "Yes. International availability depends on destination and local courier coverage.",
  //     },
  //     {
  //       q: "Can I track my order?",
  //       a: "Yes. Tracking details are sent once your order has been confirmed and dispatched.",
  //     },
  //   ],
  // },
  // {
  //   title: "Returns, Support & Partnerships",
  //   items: [
  //     {
  //       q: "What is your return policy?",
  //       a: "We offer customer support for return and refund concerns. Please contact us so we can guide you based on your order status.",
  //     },
  //     {
  //       q: "How can I become a reseller or partner?",
  //       a: "Use the Contact page and choose “Wholesale / Partnership” so our team can discuss program details with you.",
  //     },
  //     {
  //       q: "How quickly do you reply to inquiries?",
  //       a: "Most inquiries receive a response within 24 hours on business days.",
  //     },
  //   ],
  // },
];

function Header({ scrolled, isMobile, menuOpen, setMenuOpen }) {
  return (
    // <header
    //   style={{
    //     position: "fixed",
    //     top: 0,
    //     left: 0,
    //     right: 0,
    //     zIndex: 999,
    //     display: "flex",
    //     flexDirection: isMobile ? "column" : "row",
    //     alignItems: isMobile ? "flex-start" : "center",
    //     justifyContent: "space-between",
    //     gap: isMobile ? 10 : 0,
    //     padding: scrolled
    //       ? (isMobile ? "10px 16px" : "10px 52px")
    //       : (isMobile ? "14px 16px" : "22px 52px"),
    //     background: "rgba(5,44,12,0.96)",
    //     backdropFilter: "blur(14px)",
    //     borderBottom: `1px solid rgba(154,202,68,0.18)`,
    //     transition: "all 0.35s ease",
    //   }}
    // >
    <header style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 999,
      background: "rgba(5,44,12,0.96)",
      backdropFilter: "blur(14px)",
      borderBottom: `1px solid ${C.borderFaint}`,
      transition: "all 0.4s cubic-bezier(0.4,0,0.2,1)",
    }}>
      {/* <a href="/" style={{ display: "flex", alignItems: "center", gap: 12, textDecoration: "none" }}>
        <img
          src={LOGO_SRC}
          alt="SAT"
          style={{
            height: scrolled ? 36 : 50,
            transition: "height 0.35s ease",
            filter: "drop-shadow(0 2px 8px rgba(154,202,68,0.25))",
          }}
        />
        <div>
          <div style={{ fontSize: scrolled ? 13 : 15, fontWeight: 700, letterSpacing: "0.06em", color: "#FFFFFF", lineHeight: 1.1 }}>
            SYNTROPY
          </div>
          <div style={{ fontSize: scrolled ? 8 : 9, fontWeight: 500, letterSpacing: "0.25em", color: C.limeGreen, textTransform: "uppercase" }}>
            ALLIANCE TRADE
          </div>
        </div>
      </a> */}

      {/* Top bar: logo + burger (mobile) or logo + nav (desktop) */}
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: scrolled ? (isMobile ? "10px 16px" : "10px 52px") : (isMobile ? "14px 16px" : "22px 52px"),
          transition: "padding 0.4s cubic-bezier(0.4,0,0.2,1)",
        }}>
          {/* Logo */}
          <a href="/" style={{ display: "flex", alignItems: "center", gap: 12, textDecoration: "none" }}>
            <img
              src={LOGO_SRC}
              alt="SAT"
              style={{
                height: scrolled ? 36 : 50,
                transition: "height 0.35s ease",
                filter: "drop-shadow(0 2px 8px rgba(154,202,68,0.25))",
              }}
            />
            <div>
              <div style={{ fontSize: scrolled ? 13 : 15, fontWeight: 700, letterSpacing: "0.06em", color: "#FFFFFF", lineHeight: 1.1 }}>
                SYNTROPY
              </div>
              <div style={{ fontSize: scrolled ? 8 : 9, fontWeight: 500, letterSpacing: "0.25em", color: C.limeGreen, textTransform: "uppercase" }}>
                ALLIANCE TRADE
              </div>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="desktop-nav" style={{ display: "flex", gap: 36, alignItems: "center" }}>
            {NAV_LINKS.map((link) => (
              <a key={link} href={`${link.toLowerCase()}`}
                style={{ fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(230,203,161,0.7)", fontWeight: 500, transition: "color 0.2s" }}
                onMouseEnter={(e) => (e.target.style.color = C.limeGreen)}
                onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.7)")}>
                {link.replace(/#\//g, "")}
              </a>
            ))}
            <a key="affiliate-dashboard-link" href="affiliate-dashboard"
              style={{ fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(230,203,161,0.7)", fontWeight: 500, transition: "color 0.2s" }}
              onMouseEnter={(e) => (e.target.style.color = C.limeGreen)}
              onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.7)")}>
              Affiliate Dashboard
            </a>
            <a href="/shop" style={{ padding: "10px 24px", background: `linear-gradient(135deg,${C.limeGreen},${C.oliveGreen})`, color: C.darkGreen, borderRadius: 3, fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", textDecoration: "none", display: "inline-block" }}>
              Shop Now
            </a>
          </nav>

          {/* Burger Button (mobile only) */}
          <button
            className={`burger-btn${menuOpen ? " open" : ""}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>

        {/* Mobile Dropdown Menu */}
        {isMobile && menuOpen && (
          <nav style={{
            display: "flex",
            flexDirection: "column",
            gap: 0,
            borderTop: `1px solid rgba(154,202,68,0.12)`,
            animation: "slideDown 0.22s ease",
          }}>
            {NAV_LINKS.map((link) => (
              <a
                key={link}
                href={`${link.toLowerCase()}`}
                onClick={() => setMenuOpen(false)}
                style={{
                  fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase",
                  color: "rgba(230,203,161,0.75)", fontWeight: 500,
                  padding: "14px 20px",
                  borderBottom: `1px solid rgba(154,202,68,0.08)`,
                  transition: "color 0.2s, background 0.2s",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.color = C.limeGreen; e.currentTarget.style.background = "rgba(154,202,68,0.06)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(230,203,161,0.75)"; e.currentTarget.style.background = "transparent"; }}
              >
                {link.replace(/#\//g, "")}
              </a>
            ))}
            <a
              href="affiliate-dashboard"
              onClick={() => setMenuOpen(false)}
              style={{
                fontSize: 13, letterSpacing: "0.14em", textTransform: "uppercase",
                color: "rgba(230,203,161,0.75)", fontWeight: 500,
                padding: "14px 20px",
                borderBottom: `1px solid rgba(154,202,68,0.08)`,
                transition: "color 0.2s, background 0.2s",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.color = C.limeGreen; e.currentTarget.style.background = "rgba(154,202,68,0.06)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(230,203,161,0.75)"; e.currentTarget.style.background = "transparent"; }}
            >
              Affiliate Dashboard
            </a>
            <div style={{ padding: "14px 20px" }}>
              <a
                href="/shop"
                onClick={() => setMenuOpen(false)}
                style={{
                  display: "block", textAlign: "center",
                  padding: "12px 24px",
                  background: `linear-gradient(135deg,${C.limeGreen},${C.oliveGreen})`,
                  color: C.darkGreen, borderRadius: 3,
                  fontSize: 12, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase",
                }}
              >
                Shop Now
              </a>
            </div>
          </nav>
        )}
    </header>
  );
}

function Footer({ isMobile }) {
  return (
    <footer style={{ background: C.darkGreen, borderTop: "1px solid rgba(154,202,68,0.15)" }}>
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          padding: isMobile ? "36px 20px 24px" : "52px 60px 36px",
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "2fr 1fr 1fr 1fr",
          gap: isMobile ? 28 : 48,
        }}
      >
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
            <img src={LOGO_SRC} alt="SATP" style={{ height: 44, width: "auto" }} />
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#FFFFFF", letterSpacing: "0.06em" }}>SYNTROPY</div>
              <div style={{ fontSize: 8, letterSpacing: "0.22em", color: C.limeGreen }}>ALLIANCE TRADE</div>
            </div>
          </div>
          <p style={{ fontSize: 13, lineHeight: 1.7, color: "rgba(230,203,161,0.5)", maxWidth: 320 }}>
            Rooted in Purpose. Growing in Unity. Trading for Good. Powered by Digital Innovation.
          </p>
        </div>

        <div>
          <div style={{ fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: C.limeGreen, marginBottom: 18, fontWeight: 600 }}>
            Company
          </div>
          <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: 10 }}>
            <li>
              <a
                href="#/about"
                style={{ fontSize: 13, color: "rgba(230,203,161,0.45)", transition: "color 0.2s" }}
                onMouseEnter={(e) => (e.target.style.color = "rgba(230,203,161,0.85)")}
                onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.45)")}
              >
                About Us
              </a>
            </li>
          </ul>
        </div>

        <div>
          <div style={{ fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: C.limeGreen, marginBottom: 18, fontWeight: 600 }}>
            Support
          </div>
          <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: 10 }}>
            <li>
              <a
                href="#/contact"
                style={{ fontSize: 13, color: "rgba(230,203,161,0.45)", transition: "color 0.2s" }}
                onMouseEnter={(e) => (e.target.style.color = "rgba(230,203,161,0.85)")}
                onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.45)")}
              >
                Contact
              </a>
            </li>
            <li>
              <a
                href="#/faq"
                style={{ fontSize: 13, color: "rgba(230,203,161,0.45)", transition: "color 0.2s" }}
                onMouseEnter={(e) => (e.target.style.color = "rgba(230,203,161,0.85)")}
                onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.45)")}
              >
                FAQ
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div
        style={{
          borderTop: "1px solid rgba(154,202,68,0.1)",
          padding: isMobile ? "16px 20px" : "20px 60px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <span style={{ fontSize: 12, color: "rgba(230,203,161,0.3)" }}>© 2026 Syntropy Alliance Trade. All rights reserved.</span>
        <div style={{ display: "flex", gap: 24 }}>
          {["Privacy Policy", "Terms of Use", "Refund Policy"].map((l) => (
            <a
              key={l}
              href="#"
              style={{ fontSize: 11, color: "rgba(230,203,161,0.3)", letterSpacing: "0.08em", transition: "color 0.2s" }}
              onMouseEnter={(e) => (e.target.style.color = C.limeGreen)}
              onMouseLeave={(e) => (e.target.style.color = "rgba(230,203,161,0.3)")}
            >
              {l}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default function FAQPage() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  // const [openKey, setOpenKey] = useState("0-0");
  const [openKey, setOpenKey] = useState(null);
  const [viewportWidth, setViewportWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1200);

  useEffect(() => {
    window.scrollTo(0, 0);

    const onScroll = () => setScrolled(window.scrollY > 70);
    const onResize = () => {
      setViewportWidth(window.innerWidth);
      if (window.innerWidth > 768) setMenuOpen(false);
    };
    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  const isMobile = viewportWidth <= 768;

  return (
    <div style={{ fontFamily: "'Outfit', 'Segoe UI', sans-serif", background: C.pageBg, color: C.textPrimary, minHeight: "100vh", overflowX: "hidden" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,700;1,400&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: #FFFFFF; }
        a { text-decoration: none; }
        ::-webkit-scrollbar { width: 4px; }
        ::-webkit-scrollbar-thumb { background: rgba(154,202,68,0.35); border-radius: 2px; }

        /* Burger button */
        .burger-btn {
          display: none;
          flex-direction: column;
          justify-content: center;
          gap: 5px;
          background: none;
          border: none;
          cursor: pointer;
          padding: 6px;
          z-index: 1001;
        }
        .burger-btn span {
          display: block;
          width: 22px;
          height: 2px;
          background: rgba(230,203,161,0.85);
          border-radius: 2px;
          transition: transform 0.3s ease, opacity 0.3s ease;
        }
        .burger-btn.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
        .burger-btn.open span:nth-child(2) { opacity: 0; }
        .burger-btn.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

        @media (max-width: 768px) {
          .burger-btn { display: flex; }
          .desktop-nav { display: none !important; }
        }
      `}</style>

      <Header scrolled={scrolled} isMobile={isMobile} menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <section style={{ minHeight: "44vh", display: "flex", alignItems: "center", padding: isMobile ? "130px 20px 44px" : "150px 60px 80px", position: "relative" }}>
        <div style={{ maxWidth: 980, margin: "0 auto", width: "100%" }}>
          <div style={{ fontSize: 11, letterSpacing: "0.28em", textTransform: "uppercase", color: C.limeGreen, marginBottom: 14 }}>
            Help Center
          </div>
          <h1 style={{ fontSize: "clamp(32px,5vw,56px)", fontWeight: 300, lineHeight: 1.16, color: C.textPrimary, marginBottom: 18, fontFamily: "'Playfair Display', serif" }}>
            Frequently Asked <span style={{ color: C.limeGreen, fontStyle: "italic" }}>Questions</span>
          </h1>
          <p style={{ fontSize: 16, lineHeight: 1.75, color: C.textBody, maxWidth: 720 }}>
            Find quick answers about our products, shipping, and support. If you need more help, our team is one message away.
          </p>
        </div>
      </section>

      <section style={{ padding: isMobile ? "10px 20px 72px" : "20px 60px 100px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", display: "grid", gap: 22 }}>
          {FAQ_GROUPS.map((group, groupIdx) => (
            <div key={group.title} style={{ border: `1px solid ${C.border}`, borderRadius: 8, overflow: "hidden", background: C.cardBg }}>
              <div style={{ padding: isMobile ? "18px 18px" : "22px 24px", borderBottom: `1px solid ${C.border}`, background: "rgba(154,202,68,0.08)" }}>
                <h2 style={{ fontSize: isMobile ? 18 : 20, fontWeight: 600, color: C.textPrimary }}>{group.title}</h2>
              </div>
              <div>
                {group.items.map((item, itemIdx) => {
                  const itemKey = `${groupIdx}-${itemIdx}`;
                  const open = openKey === itemKey;
                  return (
                    <div key={itemKey} style={{ borderBottom: itemIdx < group.items.length - 1 ? `1px solid ${C.border}` : "none" }}>
                      <button
                        type="button"
                        onClick={() => setOpenKey(open ? "" : itemKey)}
                        style={{
                          width: "100%",
                          padding: isMobile ? "16px 18px" : "18px 24px",
                          background: "transparent",
                          border: "none",
                          textAlign: "left",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 16,
                          cursor: "pointer",
                          color: C.textPrimary,
                          fontFamily: "inherit",
                        }}
                      >
                        <span style={{ fontSize: isMobile ? 15 : 16, fontWeight: 600 }}>{item.q}</span>
                        <span style={{ fontSize: 20, color: C.limeGreen, lineHeight: 1 }}>{open ? "−" : "+"}</span>
                      </button>
                      {open && (
                        <div style={{ padding: isMobile ? "0 18px 16px 18px" : "0 24px 20px 24px", fontSize: 14, lineHeight: 1.75, color: C.textBody, whiteSpace: "pre-wrap" }}>
                          {item.a}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section style={{ padding: isMobile ? "0 20px 70px" : "0 60px 100px" }}>
        <div
          style={{
            maxWidth: 1100,
            margin: "0 auto",
            borderRadius: 10,
            border: `1px solid ${C.border}`,
            background: "linear-gradient(140deg,#FFFFFF 0%,#EDF6E3 100%)",
            padding: isMobile ? "28px 20px" : "40px 48px",
            textAlign: "center",
          }}
        >
          <div style={{ fontSize: 11, letterSpacing: "0.22em", textTransform: "uppercase", color: C.limeGreen, marginBottom: 12 }}>
            Need More Help?
          </div>
          <h3 style={{ fontSize: "clamp(24px,3vw,34px)", fontWeight: 400, color: C.textPrimary, marginBottom: 14, fontFamily: "'Playfair Display', serif" }}>
            We’re Happy to Assist You
          </h3>
          <p style={{ fontSize: 15, color: C.textBody, lineHeight: 1.75, maxWidth: 680, margin: "0 auto 26px" }}>
            If your question is not listed here, send us a message and our team will get back to you as soon as possible.
          </p>
          <a
            href="#/contact"
            style={{
              padding: "12px 26px",
              background: `linear-gradient(135deg,${C.limeGreen},${C.oliveGreen})`,
              color: C.darkGreen,
              borderRadius: 4,
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              display: "inline-block",
            }}
          >
            Contact Support
          </a>
        </div>
      </section>

      <Footer isMobile={isMobile} />
    </div>
  );
}